
      import ArrowRough from './arrow-rough.vue'
      import type { App, Plugin } from 'vue'

      export const ArrowRoughPlugin: Plugin = {
        install(app: App) {
          app.component('ArrowRough', ArrowRough)
        },
      }
      export { ArrowRough }
      